import { container, transition } from "assets/jss/style.js";
const appStyle = () => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    overflow: "auto",
    overflowX: "hidden",
    position: "relative",
    marginLeft: "auto",
    ...transition,
    height: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "60px",
    padding: "0px 0px",
    minHeight: "calc(100vh - 123px)"
  },
  container,
  map: {
    position: "relative",
    marginRight: "0px !important",
    marginLeft: "0px !important",
    height: "calc(100% - 42px)"
  }
});

export default appStyle;
